'use client';
import type { FooterTopSectionType } from '@lib/sanity/queries/footer/types';
import Anchor from '@ui/Anchor/Anchor';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';

type Props = {
  sections?: FooterTopSectionType;
};
const isOneTrust = (url?: string | null) => url === 'javascript:OneTrust.ToggleInfoDisplay()';

export default function Sections({ sections }: Props) {
  if (!sections?.length) {
    return null;
  }

  function renderLink(link: NonNullable<FooterTopSectionType[number]['links']>[number], i: number) {
    return (
      <Anchor
        href={link.url && !isOneTrust(link.url) ? (link.url ?? undefined) : undefined}
        onClick={() => isOneTrust(link.url) && window.OneTrust.ToggleInfoDisplay()}
        key={i}
        aria-label={link.title?.value ?? ''}
        className="cursor-pointer"
      >
        <Text
          content={link.title?.value}
          variant={TextVariant.TextDescription}
          className="text-foreground hover:underline hover:underline-offset-4"
        />
      </Anchor>
    );
  }

  return (
    <div
      className={cn(
        'col-span-4 sm:col-span-6 md:col-span-8 lg:col-span-9',
        'grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-9',
        'gap-8',
      )}
    >
      {sections.map((section, index) => (
        <div className="col-span-2 flex flex-col gap-4" key={index}>
          <Anchor
            href={
              section.categoryUrl && !isOneTrust(section.categoryUrl) ? (section.categoryUrl ?? undefined) : undefined
            }
            onClick={() => isOneTrust(section.categoryUrl) && window.OneTrust.ToggleInfoDisplay()}
            key={index}
            aria-label={section.categoryTitle?.value ?? ''}
            className="cursor-pointer"
          >
            <Text
              content={section.categoryTitle?.value}
              variant={TextVariant.TextUnicase}
              className="text-foreground border-border border-b py-2"
            />
          </Anchor>

          <div className="flex flex-col gap-2">{section.links?.map(renderLink)}</div>
        </div>
      ))}
    </div>
  );
}
